import React, { useState } from "react";
import GuestLayout from "../../../Layout/GuestLayout";
import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPassword from './ResetPassword';
import { useTranslation } from "../../../Context/LanguageContext";

const ForgotPassword = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <GuestLayout
                Title={t('attentionTitle')}
                Subtitle={t('attentionSubtitle')}
                FormTitle={t('forgotPasswordTitle')}
                FormSubTitle={t('forgotPasswordSubtitle')}
            >
                <ForgotPasswordForm/>            
            </GuestLayout>
        </>
    );
}
export default ForgotPassword;
